/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/oneTimeCyberAgentScanEmailVerificationMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a OneTimeCyberAgentScanEmailVerification. */
export class OneTimeCyberAgentScanEmailVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a OneTimeCyberAgentScanEmailVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Generates a security code and sends it to the email address.
   * @summary Generates a security code that is sent to the email address.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(options?: Models.OneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  generateCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(options: Models.OneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(options?: Models.OneTimeCyberAgentScanEmailVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Verifies the security code of the email address.
   * @summary Verifies the security code for the email address.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  verifyCode(options?: Models.OneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  verifyCode(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(options: Models.OneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  verifyCode(options?: Models.OneTimeCyberAgentScanEmailVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      verifyCodeOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/email/code",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationGenerateCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/OneTimeCyberAgentScan/email/verify",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.EmailVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
